import { render, staticRenderFns } from "./devices.item.vue?vue&type=template&id=1f379d28&"
import script from "./devices.item.vue?vue&type=script&lang=js&"
export * from "./devices.item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports